<div [hidden]="!includeLabel">
  <label for="{{name}}">{{getLabelName()}}</label>
</div>
<div class="border rounded mx-1 py-1 p-3">
  <div class="row mb-1" *ngIf="!detailMode">
    <div class="col">
      <ng-content></ng-content>
    </div>
    <div class="col-4">
      <div class="row">
        <label>{{''}}</label>
        <button class="btn btn-success mt-md-4 mx-1" [disabled]="!desativarBotao()" (click)="adicionarItem()">
          <i class="fa fa-plus mx-2"></i>
          Adicionar
        </button>
        <button *ngIf="permitirEdicao" class="btn btn-warning mt-md-3" (click)="modificarItem()"><i
          class="ft-edit mx-2"></i>Modificar
        </button>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div *ngIf="!this.listaVazia() then mostraLista else mostraSemLista"></div>
    <ng-template #mostraLista>
      <div class="row mb-1 ">
        <div class="col-2">
          <span *ngIf="!this.detailMode">REMOVER</span>
        </div>
        <div class="col" *ngFor="let col of this.obterCampos()">
          {{col.toUpperCase()}}
        </div>
      </div>
      <div class="row mb-1 " *ngFor="let item of this.obterLista(); let i = index">
        <hr>
        <div class="col-2">
          <span *ngIf="!this.detailMode">
            <i class="ft-trash-2 mx-2" title="Remover" (click)="this.removerItem(i)"></i>
          </span>
        </div>
        <div class="col font-weight-bold">
          <span (click)="permitirEdicao? this.carregarItem(i): null" style="cursor:pointer">{{this.listaChaves.length >
            0 ?
            obterNomeChave(item.key) : item.key}}</span>
          <span (click)="permitirEdicao? this.carregarItem(i): null" style="cursor:pointer">{{this.listaChaves.length >
            0 ?
            obterValue(item[nomeChave]):''}}</span>
        </div>
        <div class="col">
          <span *ngIf="this.usarCustomKeyValue">{{obterValue(item[nomeValor])}}</span>
          <span *ngIf="!this.usarCustomKeyValue">{{obterValue(item.value)}}</span>
        </div>
      </div>
    </ng-template>
    <ng-template #mostraSemLista>
      <span class="bg-danger text-white px-2 py-1 rounded">Nenhum item vinculado.</span>
    </ng-template>
  </div>
</div>
